import { render, staticRenderFns } from "./gds-list.vue?vue&type=template&id=dacf2462&"
import script from "./gds-list.vue?vue&type=script&lang=js&"
export * from "./gds-list.vue?vue&type=script&lang=js&"
import style0 from "./gds-list.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports